import { render } from "./addLicenseModal.vue?vue&type=template&id=f5fdaf28&ts=true"
import script from "./addLicenseModal.vue?vue&type=script&lang=ts"
export * from "./addLicenseModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__